// 运行时配置

import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import { SettingDrawer } from '@ant-design/pro-components';
import { ClerkProvider, UserButton } from '@clerk/clerk-react';
import { dark } from '@clerk/themes';
import { history, RequestConfig, RunTimeLayoutConfig } from '@umijs/max';
import { App, Button, Result } from 'antd';
import defaultSettings from '../config/defaultSettings';
import { UIProvider } from './providers/UIProvider';
import { errorConfig } from './requestErrorConfig';
import userService from './services/userService';
import clerk, { PUBLISHABLE_KEY } from './utils/clerk';

const isDev = process.env.NODE_ENV === 'development';
const homePath = '/';

const redirectUri = process.env.REACT_APP_TWITCH_REDIRECT_URI;
//const loginPath = getLoginPath(redirectUri);

// const PUBLISHABLE_KEY = process.env.CLERK_PUBLISHABLE_KEY;

// if (!PUBLISHABLE_KEY) {
//   throw new Error('Add your Clerk Publishable Key to the .env file');
// }

// const clerk = new Clerk(PUBLISHABLE_KEY);
// await clerk.load();

export const rootContainer = (container: any) => {
  return (
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY!}
      //Clerk={clerk}
      appearance={{
        baseTheme: dark,
        variables: {
          colorPrimary: '#722ED1',
        },
      }}
    >
      {container}
    </ClerkProvider>
  );
};

// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://umijs.org/docs/api/runtime-config#getinitialstate
export async function getInitialState(): Promise<{
  //loading: boolean;
  currentUser: API.Service.UserDetail | null;
  settings: Partial<LayoutSettings>;
}> {
  //const currentUser = auth.currentUser;
  //console.log('getInitialState');
  const fetchUserDetail = async () => {
    try {
      const user = await userService.getUserDetails();
      return user;
    } catch (error) {
      console.error('Failed to fetch user details:', error);
      //clerk.signOut();
    }
    return null;
  };

  return new Promise((resolve) => {
    //console.log('getInitialState 2');
    clerk.addListener(async (resources) => {
      //console.log('getInitialState 3');
      //console.log('resources', resources);
      if (resources.session && resources.user) {
        await userService.syncUser();
        const user = await fetchUserDetail();
        resolve({
          currentUser: user,
          settings: defaultSettings as Partial<LayoutSettings>,
        });
      } else {
        const initialState = {
          //loading: true,
          currentUser: null as API.Service.UserDetail | null,
          settings: defaultSettings as Partial<LayoutSettings>,
        };
        resolve(initialState);
      }
    });
  });

  // const initialState = {
  //   //loading: true,
  //   currentUser: null as API.Service.UserDetail | null,
  //   settings: defaultSettings as Partial<LayoutSettings>,
  // };

  //const hasToken = localStorage.getItem('bearer') !== null;

  // const fetchTwitchToken = async (code: string) => {
  //   try {
  //     const token = await authService.fetchTwitchToken(code);
  //     localStorage.setItem('bearer', token.access_token);
  //     localStorage.setItem('refresh', token.refresh_token);
  //     localStorage.setItem('expiry', `${token.expires_in}`);
  //     history.push(homePath);
  //   } catch (error) {
  //     console.error('Failed to fetch access token:', error);
  //   }
  // };

  // const checkTwitchLogin = async () => {
  //   const url = window.location.href;
  //   const codeMatches = url.match(/code=([^&]*)/);
  //   const errorMatches = url.match(/error=([^&]*)/);
  //   let code: string | undefined = undefined;
  //   let error: string | undefined = undefined;
  //   const hasToken = localStorage.getItem('bearer') !== null;
  //   if (codeMatches) {
  //     code = codeMatches[0].substring(5);
  //   } else if (errorMatches) {
  //     error = errorMatches[0].substring(6);
  //   }

  //   if (code) {
  //     if (hasToken) {
  //       authService.handleLogout();
  //     }

  //     localStorage.setItem('twitch', code);
  //     // await fetchToken();
  //     await fetchTwitchToken(code);
  //   } else if (error) {
  //     if (hasToken) {
  //       authService.handleLogout();
  //     }
  //   }
  // };

  // await checkTwitchLogin();

  // const hasToken = localStorage.getItem('bearer') !== null;

  // //console.log('hasToken', hasToken);
  // if (hasToken) {
  //   const user = await fetchUserDetail();

  //   if (user) {
  //     initialState.currentUser = user;
  //   }
  // }

  // return {
  //   ...initialState,
  // };
}

export const layout: RunTimeLayoutConfig = ({
  initialState,
  setInitialState,
}) => {
  return {
    actionsRender: () => [
      // <Question key="doc" />,
      // <SelectLang key="SelectLang" />,
    ],
    // avatarProps: {
    //   src:
    //     initialState?.currentUser?.profilePicture ||
    //     'https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png',
    //   title: <AvatarName />,
    //   render: (_, avatarChildren) => {
    //     return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
    //   },
    // },
    avatarProps: {
      render: () => {
        return <UserButton />;
      },
    },
    onPageChange: () => {
      //const { location } = history;
      // 如果没有登录，重定向到 login
      // if (!initialState?.currentUser) {
      //   //history.push(loginPath);
      //   window.location.href = loginPath.url;
      // }
    },

    unAccessible: (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => history.push('/')}>
            Back to Home
          </Button>
        }
      />
    ),

    noFound: (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary" onClick={() => history.push('/')}>
            Back to Home
          </Button>
        }
      />
    ),

    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <App>
          <UIProvider>
            {children}
            {isDev && (
              <SettingDrawer
                disableUrlParams
                enableDarkTheme
                settings={initialState?.settings}
                onSettingChange={(settings) => {
                  setInitialState((preInitialState: any) => ({
                    ...preInitialState,
                    settings,
                  }));
                }}
              />
            )}
          </UIProvider>
        </App>
      );
    },
    ...initialState?.settings,
  };
};

/**
 * @name request configuration, can configure error handling
 * It provides a unified network request and error handling scheme based on axios and ahooks' useRequest.
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request: RequestConfig = {
  ...errorConfig,
  baseURL: process.env.API_BASE_URL || '/api',
};
